import PagePlaceholder from '@/components/PagePlaceholder';

export default function CustomAIPage() {
  return (
    <PagePlaceholder
      title="Custom AI"
      subtitle="Discover how MorphenIQ builds AI that understands your organization, not just the world."
    />
  );
}